import { createFeature, createReducer, on } from '@ngrx/store';
import { produce } from 'immer';

import { pageContextActions } from './page-context.actions';
import { type PageContextState } from './page-context.state';

const initialState: PageContextState = {
  loaded: false,
  pageContextEntities: {},
};

export const pageContextFeature = createFeature({
  name: 'pageContext',
  reducer: createReducer(
    initialState,

    on(pageContextActions.set, (state, { pageContext }) =>
      produce(state, (draft) => {
        draft.pageContextEntities[pageContext.id] = pageContext;
      }),
    ),

    on(pageContextActions.setForOverlay, (state, { pageContext }) =>
      produce(state, (draft) => {
        for (const id of Object.keys(state.pageContextEntities)) {
          const { pageId } = state.pageContextEntities[id];
          if (pageId === pageContext.pageId) {
            delete draft.pageContextEntities[id];
          }
        }
        draft.pageContextEntities[pageContext.id] = pageContext;
      }),
    ),

    on(pageContextActions.initializeFromSessionStorage, (state, { pageContext }) => {
      return { ...state, pageContextEntities: pageContext };
    }),

    on(pageContextActions.markAsLoaded, (state) => {
      return { ...state, loaded: true };
    }),

    on(pageContextActions.initializationStart, (state) => {
      return { ...state, loaded: false, pageContextEntities: {} };
    }),

    on(pageContextActions.reset, () => {
      return { ...initialState };
    }),

    on(pageContextActions.remove, (state, { pageContextId }) => {
      return produce(state, (draft) => {
        delete draft.pageContextEntities[pageContextId];
      });
    }),
  ),
});

export const { name, reducer, selectPageContextState, selectPageContextEntities } =
  pageContextFeature;
